import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table/main';
import Form from './components/form/main';
import Filters from '../shared/fixed-filters/main';
import Calendar from '../shared/calendar/main';
import Switch from '../top-affiliates/switch/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content top-affiliates-list">
				<div className="container__content-title">
					<div className="container__content-title-position top-affiliates-title">
						<h1 className="title">{props.intl('Top affiliates')}{`:  `}{Number(props.table.rows_count)}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<Form {...props} />
						<Switch {...props} />
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}
							/>
						</div>
					</div>
					<div className="display-flex justify-content-flex-end margin-top-5">
						{
							props.can('monthlyReportView') &&
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.downloadMonthlyRanksReport.bind(null, 'countries')}
							>
								{props.intl('Monthly Report')}
							</button>
						}
						{
							props.can('monthlyReportView') &&
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.downloadMonthlyRanksReport.bind(null, 'ranks')}
							>
								{props.intl('Ranks Report')}
							</button>
						}
						<button
							className="ui-btn ui-btn-primary save margin-left-5"
							onClick={props.apply}
						>
							{props.intl('Apply')}
						</button>

					</div>
					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		isHiddenProfit: selectors.getIsHiddenProfit(state),
		noteData: selectors.getNoteData(state),
		allowedToCopyWords: selectors.getAllowedToCopyWords(state),
		notePopupData: selectors.getNotePopupData(state),
		isNotePopupVisible: selectors.getIsNotePopupVisible(state),
		loadingAffiliateId: selectors.getLoadingAffiliateId(state),
		periodSwitch: selectors.getPeriodSwitch(state),
		intl: selectors.getIntl(state),
		table: selectors.getTable(state),
		pagination: selectors.getPagination(state),
		expandedAffiliateIds: selectors.getExpandedAffiliateIds(state),
		filters: selectors.getFilters(state),
		progressBar: selectors.getProgressBar(state),
		calendar: selectors.getCalendar(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/main.js